export const publishSection = [
  '',
  `mutation publishSection($id:Int!) {
    publishSection(id:$id)
  }
`,
  'publishSection'];
